/**
 * src/connects/live-chat.js
 */

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state, ownProps)=> {
  return {
    rightSidePage: state.rightSidePage.name? true: false,
    user: state.user.current,
  }
}


export default combineHOC(
  translate(),
  connect(mapStateToProps),
  lifecycle,
)



// WEBPACK FOOTER //
// ./src/connects/live-chat.js